<template>
    <div>
        <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
            <div class="single container-max page-content" :class="{'no-multiple-images' : currentVariation.images.all.length < 2}">
				<slot name="dropzone2"></slot>

				<div class="row position-relative teaser-wrapper">

                    <div class="col-12 col-lg-6 position-static">
                        <slot name="image-carousel"></slot>
                    </div>

                    <div class="col-12 col-lg-6">
                        <div class="single-right-content">
                            <h1 class="h2 title" data-testing="item-name">
                                <span>
                                    {{ currentVariation.texts.name2 }}
                                </span>
                            </h1>

							<p class="single-description">
							   {{ currentVariation.texts.name3 }}
							</p>

							<hr class="single-short-hr">

                            <slot name="before-price"></slot>

                            <item-price v-if="!isArchive" :show-cross-price="isRecommendedPriceActive"></item-price>

							<span v-if="!isArchive" class="vat small text-muted">
                            	<a data-toggle="modal" href="#shippingscostscustom" :title="$translate('Ceres::Template.singleItemShippingCosts')"><template v-if="showNetPrices">{{ $translate("Ceres::Template.singleItemExclVAT") }}</template><template v-else>{{ $translate("Ceres::Template.singleItemInclVAT") }}</template>, {{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>
							</span>

                            <slot name="after-price"></slot>

<!--                            <item-availability></item-availability>-->

                            <div>
                                <div class="w-100">
                                    <slot name="before-add-to-basket"></slot>
                                </div>

                                <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                                    {{ $translate("Ceres::Template.singleItemSetInfo") }}
                                </div>
								<template v-else>
									<div class="col-12 col-sm-7 col-md-12 col-lg-12 basket-wrapper d-flex justify-content-center add-to-basket-wrapper">
										<add-to-basket
											:variation-id="currentVariation.variation.id"
											:is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
											:has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
											:interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
											:minimum-quantity="currentVariation.variation.minimumOrderQuantity"
											:maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
											:order-properties="currentVariation.properties.filter(function(prop) { return prop.property.isOderProperty })"
											:has-order-properties="currentVariation.hasOrderProperties"
											:has-required-order-property="currentVariation.hasRequiredOrderProperty"
											:use-large-scale="false"
											:show-quantity="true"
											:is-single="true"
											:is-archive="isArchive"
											:item-url="currentVariation | itemURL"
											:is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
											:has-price="currentVariation | hasItemDefaultPrice"
											:show-checkout="false"
											:primary-btn="true"
										>
										</add-to-basket>
									</div>
									<div class="col-12 col-sm-7 col-md-12 col-lg-12 basket-wrapper d-flex justify-content-center">
										<add-to-basket
											:variation-id="currentVariation.variation.id"
											:is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
											:has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
											:interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
											:minimum-quantity="currentVariation.variation.minimumOrderQuantity"
											:maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
											:order-properties="currentVariation.properties.filter(function(prop) { return prop.property.isOderProperty })"
											:has-order-properties="currentVariation.hasOrderProperties"
											:has-required-order-property="currentVariation.hasRequiredOrderProperty"
											:use-large-scale="false"
											:show-quantity="false"
											:is-single="true"
											:is-archive="isArchive"
											:item-url="currentVariation | itemURL"
											:is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
											:has-price="currentVariation | hasItemDefaultPrice"
											:show-checkout="true"
										>
										</add-to-basket>
									</div>
								</template>


                                <div class="w-100">
                                    <slot name="after-add-to-basket"></slot>
                                </div>
                            </div>

                            <div v-if="isWishListEnabled" class="row">
                                <div class="col-12 single-wishlist-wrapper">
                                    <add-to-wish-list :variation-id="currentVariation.variation.id"></add-to-wish-list>
                                </div>
                            </div>

							<div>
								<button type="button"
										class="btn question-modal-btn"
										@click="updateAndOpenModal">
									<svg width="16" height="16" fill="currentColor">
										<use xlink:href="#question2" />
									</svg>
									{{ $translate("HoferAntikschmuck::Template.itemQuestion") }}
								</button>
							</div>
                            <!-- ./ITEM DETAIL -->

                            <slot name="additional-content-after-add-to-basket"></slot>

                            <slot name="additional-content-after-vat"></slot>
                            <!-- END SINGLEITEM_DETAILS -->
                        </div>
                    </div>
                </div>


				<div class="hofer-hr__wrapper d-lg-none">
					<div class="hofer-hr">
						<svg class="mobile-nav__chevron" fill="currentColor">
							<use xlink:href="#logo-minimal" />
						</svg>
					</div>
				</div>


				<div class="container-inner description__wrapper">
					<img v-if="descImg.url !== '' && typeof descImg !== 'undefined'" class="description__img d-sm-none d-xl-block" :src="descImg.url" :title="currentVariation.texts.name3" :alt="currentVariation.texts.name3">

					<div class="description__content" :class="{'description__content--open': showMoreMobile}">

						<div class="description__txt">
							<img class="description__img description__img--mobile d-none d-sm-block d-xl-none" v-if="descImg.url !== '' && typeof descImg !== 'undefined'" :src="descImg.url" :title="currentVariation.texts.name3" :alt="currentVariation.texts.name3">
							<div class="description__headline">{{ $translate("HoferAntikschmuck::Template.descriptionHeadline") }}</div>

							<div class="description__translation-info" v-for="prop in allProperties" v-if="prop.id === 38 && prop.values.value === 'auto' && lang !== 'de'">
								<div class="description__translation-icon">
									<svg width="20" height="20" fill="currentColor">
										<use xlink:href="#info-circle" />
									</svg>
								</div>
								<div class="description__translation-txt">
									{{ $translate("HoferAntikschmuck::Template.translationHint") }}
								</div>
							</div>

							<span v-html="currentVariation.texts.description"></span>
						</div>

						<div class="description__quote-wrapper" v-if="quote !== '' && typeof quote !== 'undefined' && quoteAuthor !== ''">
							<img v-if="quoteImg !== ''" :src="quoteImg" :alt="quoteAuthor">

							<div class="description__quote-content-wrapper">
								<q class="description__quote">{{ quote }}</q>
								<div class="description__quote-author">{{ quoteAuthor }}</div>
							</div>
						</div>

						<div v-if="currentVariation.texts.technicalData" class="description__txt description__txt--2" :class="{'description__txt--open': showMore || showMoreMobile}">
							<div class="description__headline description__headline--2">{{ $translate("HoferAntikschmuck::Template.lernMore") }}</div>
							<span v-html="currentVariation.texts.technicalData"></span>
						</div>

						<div v-if="currentVariation.texts.technicalData !== '' && !showMoreMobile" class="description__show-more" :class="{'description__show-more--open': showMore}" @click="showMore = !showMore">
							<svg v-if="!showMore" width="8" height="8" fill="currentColor">
								<use xlink:href="#plus" />
							</svg>
							<svg v-else width="8" height="8" fill="currentColor">
								<use xlink:href="#minus" />
							</svg>

							{{ $translate("HoferAntikschmuck::Template.lernMore") }}
						</div>
					</div>

					<div v-if="!showMoreMobile" class="description__show-more-mobile d-md-none" :class="{'description__show-more-mobile--open': showMoreMobile}" @click="showMoreMobile = !showMoreMobile">
						<svg width="8" height="8" fill="currentColor">
							<use xlink:href="#plus" />
						</svg>

						{{ $translate("HoferAntikschmuck::Template.readMore") }}
					</div>
				</div>

				<div class="details__bg" v-if="!isCoupon">
					<div class="details__wrapper container-inner">
						<div class="details__content">
							<div class="details__headline">{{ $translate("HoferAntikschmuck::Template.detailsHeadline") }}</div>
							<client-only>
								<slot name="item-props"></slot>
							</client-only>
						</div>
						<div class="details__video">
							<div class="single__video-right">
								<template v-if="videoProp !== ''">
									<div v-show="!videoPlaying" class="single__video-play" v-if="videoProp.values.value && videoProp.values.value !== ''" @click="videoPlay()">
										<svg>
											<use xlink:href="#play" />
										</svg>
									</div>
									<div class="video-wrapper" :class="{'playing': videoPlaying}" v-if="videoProp.values.value && videoProp.values.value !== ''">
										<video @click="videoPause()"
											   ref="video"
											   playsinline
											   muted loop
											   preload="none"
											   class="single__video-player"
											   :src="videoProp.values.value.replace('http:', 'https:')"
											   :poster="replacePoster(videoProp.values.value.replace('http:', 'https:'))">
										</video>
									</div>
									<img v-else-if="videoImg.url && videoImg.url !== '' && typeof videoImg.url !== 'undefined'" :src="videoImg.url" alt="video">

								</template>

								<img v-else-if="videoImg.url && videoImg.url !== '' && typeof videoImg.url !== 'undefined'" :src="videoImg.url" alt="video">
							</div>
						</div>
					</div>
				</div>

				<div v-if="!isArchive" class="small-add-to-basket">
					<img  class="small-add-to-basket__img" :src="currentVariation.images.all[0].url" :title="currentVariation.texts.name3" :alt="currentVariation.texts.name3">

					<div class="small-add-to-basket__content">
						<span class="small-add-to-basket__item-name">{{ currentVariation.texts.name2 }}</span>
						<div class="small-add-to-basket__price-vat-wrapper">
							<item-price :show-cross-price="isRecommendedPriceActive"></item-price>
							<span class="vat small text-muted">
                            	<a data-toggle="modal" href="#shippingscostscustom" :title="$translate('Ceres::Template.singleItemShippingCosts')"><template v-if="showNetPrices">{{ $translate("Ceres::Template.singleItemExclVAT") }}</template><template v-else>{{ $translate("Ceres::Template.singleItemInclVAT") }}</template>, {{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>
							</span>
						</div>

						<add-to-basket
							:is-archive="isArchive"
							:variation-id="currentVariation.variation.id"
							:is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
							:has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
							:interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
							:minimum-quantity="currentVariation.variation.minimumOrderQuantity"
							:maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
							:order-properties="currentVariation.properties.filter(function(prop) { return prop.property.isOderProperty })"
							:has-order-properties="currentVariation.hasOrderProperties"
							:has-required-order-property="currentVariation.hasRequiredOrderProperty"
							:use-large-scale="false"
							:show-quantity="false"
							:is-single="true"
							:item-url="currentVariation | itemURL"
							:is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
							:has-price="currentVariation | hasItemDefaultPrice"
							:show-checkout="false"
							:primary-btn="true"

						>
						</add-to-basket>
					</div>

				</div>

                <slot name="dropzone1"></slot>
                <slot name="item-list-container"></slot>
                <slot name="feedback-container"></slot>
            </div>
        </slot>
    </div>
</template>

<script>
import { get } from "ceres/app/helper/get";
import { isNullOrUndefined } from "ceres/app/helper/utils";

export default {

    name: "single-item",

    props: {
        pleaseSelectOptionVariationId: {
            type: Number,
            default: 0
        },
        initPleaseSelectOption: {
            type: Boolean,
            default: false
        },
        showNetPrices: {
            type: Boolean,
            default: false
        },
        isWishListEnabled: {
            type: Boolean,
            default: false
        },
        itemId: {
            type: Number,
            required: true
        },
        afterKey: Object
    },

	data() {
		return {
			showMore: false,
			showMoreMobile: false,
			videoPlaying: false,
			quoteAuthor: "",
			quoteImg: "",
			opendBefore: false,
		}
	},

    jsonDataFields: [
        "itemData",
        "attributesData",
        "variations"
    ],

    provide()
    {
        return {
            itemId: this.$props.itemId
        }
    },

    computed:
    {

		videoProp(){
			for(let key in this.allProperties){
				if(this.allProperties[key].id === 40){
					return this.allProperties[key]
				}
			}

			return ''
		},

		quote(){
			for(let key in this.allProperties){
				if(this.allProperties[key].id === 36 && this.allProperties[key].values.value !== ""){
					return this.allProperties[key].values.value
				}
			}
		},

		lang(){
			return App.language
		},

		isArchive(){
			for (let key in this.currentVariation.defaultCategories){
				if(this.currentVariation.defaultCategories[key].id === 80){
					return true
				}
			}

			return false
		},

		isCoupon(){
			for (let key in this.currentVariation.defaultCategories){
				if(this.currentVariation.defaultCategories[key].id === 62){
					return true
				}
			}

			return false
		},

		descImg(){
			for(let key in this.allProperties){
				if(this.allProperties[key].id === 79){
					if(this.allProperties[key].values.value !== '' && typeof this.allProperties[key].values.value !== "undefined" && this.allProperties[key].values.value < this.currentVariation.images.all.length){
						return this.currentVariation.images.all[this.allProperties[key].values.value]
					}
					else{
						return this.currentVariation.images.all[1]
					}
				}
			}

			return this.currentVariation.images.all[1]

		},
		videoImg(){
			for(let key in this.allProperties){
				if(this.allProperties[key].id === 80){
					if(this.allProperties[key].values.value !== '' && typeof this.allProperties[key].values.value !== "undefined" && this.allProperties[key].values.value < this.currentVariation.images.all.length){
						return this.currentVariation.images.all[this.allProperties[key].values.value]
					}
					else{
						return this.currentVariation.images.all[0]
					}
				}
			}

			return this.currentVariation.images.all[0]
		},

		pluginPath(){
			return App.pluginPath
		},

		allProperties(){
			let allProps = []

			for(let key1 in this.currentVariation.variationProperties){
				for (let key2 in this.currentVariation.variationProperties[key1].properties){
					allProps.push(this.currentVariation.variationProperties[key1].properties[key2])
				}
			}

			return allProps
		},

        itemConfig()
        {
            return App.config.item.itemData;
        },

        isDescriptionTabActive()
        {
            return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all"))
                && !!this.currentVariation.texts.description.length;
        },

        isRecommendedPriceActive()
        {
            return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
        },

        isShortDescriptionActive()
        {
            return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
        },

        hasShippingCostsCategoryId()
        {
            return App.config.global.shippingCostsCategoryId > 0;
        },

        isTechnicalDataTabActive()
        {
            return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all"))
                && !!this.currentVariation.texts.technicalData.length;
        },

        variationGroupedProperties()
        {
            return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
        },

        variationMissingProperties()
        {
            return this.$store.getters[`${this.itemId}/variationMissingProperties`];
        },

        currentVariation() {
            return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
        },

        isVariationSelected() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
        },

        attributes() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
        },

        units() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
        },

        isItemSet() {
            return this.$store.state.items.isItemSet;
        }
    },

    created()
    {
        this.$store.dispatch("initVariation", this.itemData);
        this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
    },

    mounted()
    {


        this.$nextTick(() =>
        {
            this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
                itemId:             this.itemId,
                attributes:         this.attributesData,
                variations:         this.variations,
                initialVariationId: this.currentVariation.variation.id,
                isPleaseSelectOption: this.initPleaseSelectOption,
                afterKey:           this.afterKey
            });

            if (this.isItemSet)
            {
                this.$store.dispatch("initSetComponents", this.itemData);
            }

			this.quoteAuthorAndImg()
		})

        // listen for variation change to hydrate all children lazy-hydrate components
        document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
    },

    methods:
    {
		quoteAuthorAndImg(){
			for(let key in this.allProperties){
				if(this.allProperties[key].id === 37 && this.allProperties[key].values.value !== ""){
					if(this.allProperties[key].values.value === "fh"){
						this.quoteAuthor = "Florian Horsthemke";
						this.quoteImg = "https://cdn02.plentymarkets.com/4zgmsw446bbj/frontend/static/hofer-team-quote-fh.jpg"
					}
					else if(this.allProperties[key].values.value === "dk"){
						this.quoteAuthor = "Deborah Kruck";
						this.quoteImg = "https://cdn02.plentymarkets.com/4zgmsw446bbj/frontend/static/hofer-team-quote-dk.jpg"
					}
					else if(this.allProperties[key].values.value === "jd"){
						this.quoteAuthor = "Franz-Josef Dröge";
						this.quoteImg = "https://cdn02.plentymarkets.com/4zgmsw446bbj/frontend/static/hofer-team-quote-jd.jpg"
					}
					else if(this.allProperties[key].values.value === "ld"){
						this.quoteAuthor = "Lea Döding";
						this.quoteImg = "https://cdn02.plentymarkets.com/4zgmsw446bbj/frontend/static/hofer-team-quote-ld.jpg"
					}
					else if(this.allProperties[key].values.value === "mh"){
						this.quoteAuthor = "Malte Hesemann";
						this.quoteImg = "https://cdn02.plentymarkets.com/4zgmsw446bbj/frontend/static/hofer-team-quote-mh.jpg"
					}
					else if(this.allProperties[key].values.value === "sh"){
						this.quoteAuthor = "Simon Hofer";
						this.quoteImg = "https://cdn02.plentymarkets.com/4zgmsw446bbj/frontend/static/hofer-team-quote-sh.jpg"
					}

					else {
						this.quoteAuthor = ""
					}
				}
			}
		},

		updateAndOpenModal() {

			if(!this.opendBefore){
				let subject = document.querySelector('[data-mail="subject"]');

				subject.value = subject.value + ' - ' + this.currentVariation.variation.number

				this.opendBefore = true
			}


			$('#item-question').modal('show');

		},

		videoPlay(){
			this.$refs.video.play()
			this.videoPlaying = true;
		},

		videoPause(){
			if(!this.$refs.video.paused){
				this.$refs.video.pause();
				this.videoPlaying = false;
			}
		},


		replacePoster(poster){
			poster = poster.replace("mov", "jpg");
			poster = poster.replace("mp4", "jpg");

			return poster
		},

        getDataField(field)
        {
            return get(this.currentVariation, field);
        },

        getFilteredDataField(field, filter)
        {
            if (!isNullOrUndefined(this.$options.filters[filter]))
            {
                return this.$options.filters[filter](this.getDataField(field));
            }

            return this.getDataField(field);
        },

        // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
        hydrateChildren(nodes)
        {
            nodes.forEach(component => {
                if (component.$options.name === "lazy-hydrate")
                {
                    component.hydrate();
                }
                else if (component.$children.length)
                {
                    this.hydrateChildren(component.$children);
                }
            })
        }
    }
}
</script>
